import { Query } from '@shared/utils';

interface FixOptions {
    initialSearch: string;
    query: Query;
    queryName: string | undefined;
}

export function fixSearchQuery(options: FixOptions): string {
    const { initialSearch, query, queryName } = options;

    if (queryName) {
        const querySearch = query[queryName];
        if (typeof querySearch === 'boolean') {
            return `${querySearch}`;
        } else if (typeof querySearch === 'object' || typeof querySearch === 'undefined') {
            return initialSearch;
        } else {
            return querySearch;
        }
    } else {
        return initialSearch;
    }
}
